import axios from "axios";
import * as helper from "./serviceHelpers";

type CreateUserRequest = {
  firstName: string;
  lastName: string;
  email: string;
  allowNotifications: boolean;
  organization: string;
  jobRole: string;
  serialNumber: string;
};

type UserResetEmail = {
  email: string;
};

type ResetPasswordRequest = {
  pwd: string;
  verifypwd: string;
};

const registerUser = (request: CreateUserRequest) => {
  const config = {
    method: "POST",
    url: "/olisigner/register",
    crossdomain: true,
    data: request,
    headers: {
      "Content-Type": "application/json"
    }
  };

  return axios(config).then(helper.onGlobalSuccess).catch(helper.onGlobalError);
};

const resetPassword = (request: UserResetEmail) => {
  const config = {
    method: "POST",
    url: "/olisigner/resetcredential",
    crossdomain: true,
    data: request,
    headers: {
      "Content-Type": "application/json"
    }
  };

  return axios(config).then(helper.onGlobalSuccess).catch(helper.onGlobalError);
};

const updatePassword = (request: ResetPasswordRequest, token: String) => {
  const config = {
    method: "POST",
    url: `/olisigner/credentials/${token}`,
    crossdomain: true,
    data: request,
    headers: {
      "Content-Type": "application/json"
    }
  };

  return axios(config).then(helper.onGlobalSuccess).catch(helper.onGlobalError);
};

const validateToken = (emailToken: string) => {
  const config = {
    method: "GET",
    url: `/olisigner/validate/${emailToken}`,
    crossdomain: true,

    headers: {
      "Content-Type": "application/json"
    }
  };

  return axios(config).then(helper.onGlobalSuccess).catch(helper.onGlobalError);
};

const healthCheck = () => {
  const config = {
    method: "GET",
    url: "/olisigner/healthcheck",
    crossdomain: true,

    headers: {
      "Content-Type": "application/json"
    }
  };

  return axios(config).then(helper.onGlobalSuccess).catch(helper.onGlobalError);
};

export { registerUser, resetPassword, updatePassword, validateToken, healthCheck };
